import { Component, computed, input } from '@angular/core';
import qrcode from 'qrcode-generator';

/** Margine bianco attorno al codice, in moduli: le app lo richiedono per riconoscerlo. */
const QUIET_ZONE = 4;

/**
 * Un QR code disegnato come SVG.
 *
 * I moduli diventano un unico `<path>` legato con un attributo, invece di un SVG prodotto
 * come stringa e inserito con `innerHTML`: Angular lo sanificherebbe, e non serve fidarsi di
 * un markup quando bastano delle coordinate. È sempre nero su bianco, anche col tema scuro:
 * a colori invertiti molte fotocamere non lo leggono.
 */
@Component({
  selector: 'app-qr-code',
  template: `
    <svg
      [attr.viewBox]="'0 0 ' + size() + ' ' + size()"
      shape-rendering="crispEdges"
      role="img"
      [attr.aria-label]="label()"
    >
      <rect [attr.width]="size()" [attr.height]="size()" fill="#fff" />
      <path [attr.d]="path()" fill="#000" />
    </svg>
  `,
  styles: `
    :host {
      display: block;
    }

    svg {
      display: block;
      height: 100%;
      width: 100%;
    }
  `,
})
export class QrCode {
  readonly value = input.required<string>();
  readonly label = input('Codice QR');

  private readonly code = computed(() => {
    const qr = qrcode(0, 'M');
    qr.addData(this.value());
    qr.make();
    return qr;
  });

  protected readonly size = computed(() => this.code().getModuleCount() + QUIET_ZONE * 2);

  protected readonly path = computed(() => {
    const qr = this.code();
    const count = qr.getModuleCount();
    let d = '';
    for (let row = 0; row < count; row++) {
      for (let col = 0; col < count; col++) {
        if (qr.isDark(row, col)) {
          d += `M${col + QUIET_ZONE} ${row + QUIET_ZONE}h1v1h-1z`;
        }
      }
    }
    return d;
  });
}
